import React, { Component } from "react";
import SummaryTransactions from "../components/SummaryTransactions";
import MarketAnalysis from "./../components/market-analysis/MarketAnalysis";
import MySales from "../components/my-sales/MySales";

class Sale extends Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		return <MySales />;
	}
}

export default Sale;
